import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Grid } from '@naf/grid';
import { nafColor } from '@nafcore/theme';
import { breakpoints, spacing } from '@naf/theme';

export const yellow20Border = `1px solid ${nafColor.signature.yellow20}`;
export const neutral1Border = `1px solid ${nafColor.neutral.neutral1}`;

export const ErrorWrapper = styled.div`
  text-align: center;
  padding-top: ${spacing.space48};
  padding-bottom: ${spacing.space64};

  p {
    margin-top: ${spacing.space8};
  }

  h2 {
    margin-bottom: ${spacing.space8};
  }

  div {
    margin: 0 auto;
  }
`;

export const Wrapper = styled.nav<{
  $menuOffset: number;
  $isMenuOpen?: boolean;
}>`
  z-index: 15;
  max-width: 1400px;
  box-sizing: border-box !important;
  margin: 0;
  padding: 0 ${spacing.space16};
  border-radius: 0 0 ${spacing.space8} ${spacing.space8};

  /* Always in DOM for SEO, but visually hidden when closed. */
  ${({ $isMenuOpen }) =>
    $isMenuOpen === false &&
    css`
      position: absolute !important;
      opacity: 0;
      pointer-events: none;
      visibility: hidden;
      height: 0 !important;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      width: 1px;
    `}

  ${({ $isMenuOpen }) =>
    $isMenuOpen === true &&
    css`
      opacity: 1;
      pointer-events: auto;
      visibility: visible;
    `}

  ${({ $isMenuOpen }) =>
    $isMenuOpen &&
    css`
      border-left: ${yellow20Border};
      border-right: ${yellow20Border};
      border-bottom: ${yellow20Border};
      background-color: ${nafColor.signature.yellow10};
      height: auto;
      overflow-y: hidden;
      padding-bottom: 0;
    `}

  /* Hidden from users on mobile (MobileMenuOverlay takes over), but kept in DOM for SEO. */
  @media (max-width: ${breakpoints.l}) {
    position: absolute !important;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    height: 0 !important;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    width: 1px;
  }

  .margin-top {
    margin-top: ${spacing.space32};
  }
`;

export const Content = styled.div`
  max-width: 1400px;
  padding: 0 ${spacing.space32} ${spacing.space12} ${spacing.space32};
  margin: auto;
  left: 0;
  right: 0;
`;

export const StyledGrid = styled(Grid)`
  min-height: 100%;
  align-items: flex-start;
  row-gap: ${spacing.space24};
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-top: ${spacing.space24};
`;

export const HighlightedLinksWrapper = styled.div`
  background-color: ${nafColor.signature.white};
  border-radius: ${spacing.space4};
  padding: ${spacing.space12};
`;

export const RoadsideAssistanceButtonWrapper = styled.div`
  /* Navbar resets box-sizing to content-box for all descendants, breaking the button's width="full". */
  > a {
    box-sizing: border-box !important;
  }
`;
